import { render, staticRenderFns } from "./ListaCompetencia.vue?vue&type=template&id=193e1b9e"
import script from "./ListaCompetencia.vue?vue&type=script&lang=js"
export * from "./ListaCompetencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports